import { render, staticRenderFns } from "./PortfolioListMyLayout.vue?vue&type=template&id=8aab42dc&scoped=true&"
import script from "./PortfolioListMyLayout.vue?vue&type=script&lang=js&"
export * from "./PortfolioListMyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aab42dc",
  null
  
)

export default component.exports